module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/red/RideClub_Milestones_App_250-Red-6234285de8f185c82ce6779dd07d596c.png";